angular.module('bmsApp.merrymaids.job')
	.controller('BulkInactiveOneOffJobCtrl', BulkInactiveOneOffJobCtrl);

BulkInactiveOneOffJobCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'$ngBootbox',
	'notify',
	'MMJobSvc',
];



function BulkInactiveOneOffJobCtrl(
	$scope,
	$state,
	$q,
	$ngBootbox,
	notify,
	MMJobSvc,
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: true,
		handlers: handlers,
		inactiveCount: 0,
		processing: false,
	});

	this.$onInit = () => {
		handlers.loadJobs();
	};

	function calculateInactive() {
		self.inactiveCount = 0;
		angular.forEach(self.jobCollection, (item) => {
			angular.forEach(item.jobs, (job) => {
				if (job.selected) {
					self.inactiveCount++;
				}
			});
		});
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.loadJobs = () => {
		self.loading = true;
		let params = {
			filter: {
				jobPartNotActiveInTwelveMonths: true,
				customerNotCleansed: true,
				cleaningFrequency: 'one_off',
				active: true,
			},
			skipPagination: true,
		};
		MMJobSvc.index(params).then((response) => {
			self.jobCollectionTmp = response.data.job_collection;
			let jobByCustomer = _.groupBy(self.jobCollectionTmp, (job) =>
			{
				return job.customer.id;
			});

			self.jobCollection = [];

			// Transform the data to give easy access to customer object and jobs
			angular.forEach(jobByCustomer, (customerObject) => {
				self.jobCollection.push({
					customer: customerObject[0].customer,
					jobs: customerObject,
				});
			});
			self.loading = false;
		});
	};

	handlers.selectAllClick = () => {
		angular.forEach(self.jobCollection, (item) => {
			angular.extend(item, {
				selected: self.selectAll,
			});
			angular.forEach(item.jobs, (job) => {
				angular.extend(job, {
					selected: self.selectAll,
				});
			});
		});
		calculateInactive();
	};

	handlers.customerClick = (item) => {
		angular.forEach(item.jobs, (job) => {
			angular.extend(job, {
				selected: item.selected,
			});
		});
		calculateInactive();
	};

	handlers.jobClick = (item) => {
		calculateInactive();
	};



	handlers.submitClick = () => {
		$ngBootbox.confirm('CAUTION: Are you sure you want to make ' + self.inactiveCount + ' jobs inactive? THIS CANNOT BE UNDONE')
			.then(function () {
				self.processing = true;
				let jobIds = [];
				angular.forEach(self.jobCollection, (item) => {
					angular.forEach(item.jobs, (job) => {
						if (job.selected) {
							jobIds.push(job.id);
						}
					});
				});

				let params = {
					jobIds: jobIds,
				};

				MMJobSvc.bulkInactive(params).then((response) => {
					notify({
						message: self.inactiveCount + ' jobs made inactive',
					});
					self.selectAll = false;
					self.processing = false;
					handlers.loadJobs();
				});

			});
	};
}
